// Bump on release; shown in the sidebar and the About dialog.
// Convention: a functionality change bumps the minor (+0.1, e.g. 1.0.0 -> 1.1.0);
// a fix bumps the patch (+0.01, e.g. 1.0.0 -> 1.0.1).
export const APP_VERSION = '1.62.0'
